import { render, staticRenderFns } from "./AddDetail.vue?vue&type=template&id=0ff49cec&scoped=true&"
import script from "./AddDetail.vue?vue&type=script&lang=js&"
export * from "./AddDetail.vue?vue&type=script&lang=js&"
import style0 from "./AddDetail.vue?vue&type=style&index=0&id=0ff49cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff49cec",
  null
  
)

export default component.exports